import styles from './MissingInstallationFallback.module.less';
import Button, { BUTTON_SIZE, BUTTON_TYPE } from '../../../generic/Button';
import Flex from '../../../generic/Flex';
import { connectToGitHub } from '../../../settings/integrations/gitHubApp/util';
import { useRouter } from '../../../../contexts/RouterContext';

const MissingInstallationFallback = () => {
  const router = useRouter();

  return (
    <div className={styles.missingInstallationFallback}>
      <Flex direction="column" gap="8px">
        <img src="/img/fossa-logo-circle.svg" alt="FOSSA" width="64px" />
        <div className={styles.title}>No Github App Connected</div>
        <div className={styles.description}>
          If you’ve already installed the app in Github you may need to provide us with the Github App ID.
        </div>
      </Flex>
      <div className={styles.buttons}>
        <Button
          onClick={() => {
            connectToGitHub('quick-import');
          }}
          size={BUTTON_SIZE.MEDIUM}
        >
          Install a new Github App
        </Button>
        <Button
          onClick={() => {
            router.push('/account/settings/integrations/github-app');
          }}
          size={BUTTON_SIZE.MEDIUM}
          type={BUTTON_TYPE.SECONDARY}
        >
          Connect an installed Github App
        </Button>
      </div>
    </div>
  );
};

export default MissingInstallationFallback;
